<template>
  <div class="ApiDocument">
    <div class="top" @click="initDoc">
      <img id="logo" src="../assets/logo.png" />
      <h2>API Test</h2>
    </div>

    <div class="content">
      <div class="backBtn" @click="goBack" v-if="showBack">
        <i class="el-icon-place"></i>
        <span>GAMES</span>
      </div>

      <div class="agnetBox">
        <el-input
          placeholder="Please Input MerchantCode"
          v-model="merchantCode"
          maxlength="36"
          class="agentType"
        >
          <template slot="prepend">merchantCode</template>
        </el-input>
        <el-input
          placeholder="Please Input Agent"
          v-model="agentKey"
          maxlength="20"
          @change="changeKey"
          class="agentType"
        >
          <template slot="prepend">agent</template>
        </el-input>
        <el-input
          placeholder="Please Input Domain"
          v-model="domainName"
          maxlength="20"
          @change="changeDomain"
          class="agentType"
        >
          <template slot="prepend">domain</template>
        </el-input>
      </div>

      <div class="docBox">
        <!-- player ********************************************* -->
        <div class="group">
          <h2 class="groupTitle">PLAYER</h2>
          <div class="apiBox">
            <span class="apiTitle">createPlayer</span>
            <el-input v-model="createPlayerForm.playerID" maxlength="36">
              <template slot="prepend">playerID</template>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="createPlayer"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.createPlayer"
              readonly
            >
            </el-input>
          </div>

          <div class="apiBox">
            <span class="apiTitle">kickPlayer</span>
            <el-input
              placeholder="Please Input playerID"
              v-model="kickPlayerForm.playerID"
              class="input-with-select"
              maxlength="36"
            >
              <el-select
                v-model="kickPlayerForm.actionType"
                slot="prepend"
                placeholder="Select"
                class="holderType"
              >
                <el-option label="Single Player(0)" value="0"></el-option>
                <el-option label="All Player Of Agent(1)" value="1"></el-option>
              </el-select>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="kickPlayer"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.kickPlayer"
              readonly
            >
            </el-input>
          </div>

          <div class="apiBox">
            <span class="apiTitle">lockPlayer</span>
            <el-input v-model="lockPlayerForm.playerID" maxlength="36">
              <template slot="prepend">playerID</template>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="lockPlayer"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.lockPlayer"
              readonly
            >
            </el-input>
          </div>

          <div class="apiBox">
            <span class="apiTitle">unLockPlayer</span>
            <el-input v-model="unLockPlayerForm.playerID" maxlength="36">
              <template slot="prepend">playerID</template>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="unLockPlayer"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.unLockPlayer"
              readonly
            >
            </el-input>
          </div>

          <div class="apiBox">
            <span class="apiTitle">playerStatus</span>
            <el-input v-model="playerStatusForm.playerID" maxlength="36">
              <template slot="prepend">playerID</template>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="playerStatus"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.playerStatus"
              readonly
            >
            </el-input>
          </div>
        </div>

        <!-- PLAY GAME ********************************************* -->

        <div class="group">
          <h2 class="groupTitle">PLAY GAME</h2>
          <div class="apiBox">
            <span class="apiTitle">playGame</span>

            <el-input v-model="playGameForm.playerID" maxlength="36">
              <template slot="prepend">playerID</template>
            </el-input>
            <el-input
              v-model="playGameForm.returnUrl"
              placeholder="(Optional)"
              maxlength="60"
            >
              <template slot="prepend">returnUrl</template>
            </el-input>

            <el-input
              v-model="playGameForm.hasCurrency"
              placeholder="true/false(Optional)"
              maxlength="60"
            >
              <template slot="prepend">hasCurrency</template>
            </el-input>
            <el-input
              v-model="playGameForm.hasLogo"
              placeholder="true/false(Optional)"
              maxlength="20"
            >
              <template slot="prepend">hasLogo</template>
            </el-input>

            <el-input
              placeholder="Please Input gameCode"
              v-model="playGameForm.gameCode"
              class="input-with-select"
              maxlength="20"
            >
              <el-select
                v-model="playGameForm.lang"
                slot="prepend"
                placeholder="lang"
                maxlength="20"
                class="holderType"
              >
                <el-option label="zh-CN" value="zh-CN"></el-option>
                <el-option label="th" value="th"></el-option>
                <el-option label="en" value="en"></el-option>
              </el-select>
           
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="playGame2"
                class="send"
              ></el-button>
            </el-input>

            <el-select
                v-model="playGameForm.walletType"
                slot="prepend"
                placeholder="錢包類型"
                maxlength="20"
                class="holderType"
              >
                <el-option label="一般錢包" :value="0"></el-option>
                <el-option label="免轉錢包" :value="2"></el-option>
              </el-select>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.playGame"
              readonly
            >
            </el-input>
          </div>

          <div class="apiBox">
            <span class="apiTitle">playLobby</span>
            <el-input v-model="tmpId" maxlength="20">
              <template slot="prepend">playerID</template>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="playLobby2"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.playLobby"
              readonly
            >
            </el-input>
          </div>

          <div class="apiBox">
            <span class="apiTitle">trialPlayGame</span>
            <el-input v-model="trialPlayGameForm.gameCode" maxlength="20">
              <template slot="prepend">gameCode</template>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="trialPlayGame"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.trialPlayGame"
              readonly
            >
            </el-input>
          </div>
        </div>

        <div class="group">
          <h2 class="groupTitle">POINTS</h2>

          <div class="apiBox">
            <span class="apiTitle">deposit</span>

            <el-input v-model="depositForm.playerID" maxlength="36">
              <template slot="prepend">playerID</template>
            </el-input>
            <el-input v-model="depositForm.transferID" maxlength="40">
              <template slot="prepend">transferID</template>
            </el-input>

            <el-input v-model="depositForm.pointAmount" maxlength="9">
              <template slot="prepend">pointAmount</template>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="deposit"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.deposit"
              readonly
            >
            </el-input>
          </div>

          <div class="apiBox">
            <span class="apiTitle">withdrawal</span>

            <el-input v-model="withdrawalForm.playerID" maxlength="36">
              <template slot="prepend">playerID</template>
            </el-input>
            <el-input v-model="withdrawalForm.transferID" maxlength="40">
              <template slot="prepend">transferID</template>
            </el-input>

            <el-input
              placeholder="Please Input pointAmount"
              v-model="withdrawalForm.pointAmount"
              maxlength="9"
              class="input-with-select"
            >
              <el-select
                v-model="withdrawalForm.pickType"
                slot="prepend"
                placeholder="Select"
                class="holderType"
              >
                <el-option label="Withdrawal All(F)" value="F"></el-option>
                <el-option label="Withdrawal Custom(C)" value="C"></el-option>
              </el-select>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="withdrawal"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.withdrawal"
              readonly
            >
            </el-input>
          </div>

          <div class="apiBox">
            <span class="apiTitle">checkTransfer</span>
            <el-input v-model="checkTransferForm.transferID" maxlength="40">
              <template slot="prepend">transferID</template>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="checkTransfer"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.checkTransfer"
              readonly
            >
            </el-input>
          </div>
          <div class="apiBox">
            <span class="apiTitle">queryPoint</span>
            <el-input v-model="queryPointForm.playerID" maxlength="36">
              <template slot="prepend">playerID</template>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="queryPoint"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.queryPoint"
              readonly
            >
            </el-input>
          </div>
        </div>

        <div class="group">
          <h2 class="groupTitle">RECORD</h2>

          <div class="apiBox">
            <span class="apiTitle">gamerecordbyTime</span>

            <el-input
              v-model="gameRecordByTimeForm.beginDateTime"
              maxlength="20"
              placeholder="YYYY-MM-DD HH:mm ex:(2021-01-01 00:00)"
            >
              <template slot="prepend">beginDateTime</template>
            </el-input>
            <el-input
              v-model="gameRecordByTimeForm.endDateTime"
              maxlength="20"
              placeholder="YYYY-MM-DD HH:mm ex:(2021-01-01 00:00)"
            >
              <template slot="prepend">endDateTime</template>
            </el-input>

            <el-input v-model="gameRecordByTimeForm.gameType" maxlength="20">
              <template slot="prepend">gameType</template>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="gameRecordByTime"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.gamerecordbyTime"
              readonly
            >
            </el-input>
          </div>

          <div class="apiBox">
            <span class="apiTitle">tradeRecordByTime</span>

            <el-input
              v-model="tradeRecordByTimeForm.beginDateTime"
              maxlength="20"
              placeholder="YYYY-MM-DD HH:mm:ss ex:(2021-01-01 00:00:00)"
            >
              <template slot="prepend">beginDateTime</template>
            </el-input>
            <el-input
              v-model="tradeRecordByTimeForm.endDateTime"
              maxlength="20"
              placeholder="YYYY-MM-DD HH:mm:ss ex:(2021-01-01 00:00:00)"
            >
              <template slot="prepend">endDateTime</template>
            </el-input>

            <el-input v-model="tradeRecordByTimeForm.playerID" maxlength="36">
              <template slot="prepend">playerID</template>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="tradeRecordByTime"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.tradeRecordByTime"
              readonly
            >
            </el-input>
          </div>

          <div class="apiBox">
            <span class="apiTitle">onlineplayers</span>

            <el-input v-model.trim="onlineplayers.pageIndex" maxlength="60">
              <template slot="prepend">pageIndex</template>
            </el-input>
            <el-input v-model.trim="onlineplayers.pageSize" maxlength="60">
              <template slot="prepend">pageSize</template>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="getonlineplayers"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.onlineplayers"
              readonly
            >
            </el-input>
          </div>

          <div class="apiBox">
            <span class="apiTitle">playerGameDetail</span>
            <el-input v-model="playerGameDetail.gameTurn" maxlength="60">
              <template slot="prepend">gameTurn</template>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="getGameDetail"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.playerGameDetail"
              readonly
            >
            </el-input>
          </div>

          <div class="apiBox">
            <span class="apiTitle">playerdailyreport</span>
            <el-input
              v-model="playerDailyReport.gameDate"
              maxlength="60"
              placeholder="YYYY-MM-DD ex:(2021-01-01)"
            >
              <template slot="prepend">gameDate</template>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="getPlayerDailyReport"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.playerdailyreport"
              readonly
            >
            </el-input>
          </div>

          <div class="apiBox">
            <span class="apiTitle">playerspoint</span>
            <el-input v-model.trim="playerID" maxlength="60">
              <template slot="prepend">playerID</template>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="getplayerspoint"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.playerspoint"
              readonly
            >
            </el-input>
          </div>

          <div class="apiBox">
            <span class="apiTitle">jackpotstatus</span>
            <div>
              <el-button
                type="primary"
                icon="el-icon-document"
                @click="getJackpotStatus"
                class="send"
                >jackpotstatus</el-button
              >
            </div>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.jackpotstatus"
              readonly
            >
            </el-input>
          </div>

          <div class="apiBox">
            <span class="apiTitle">gameList</span>
            <div>
              <el-button
                type="primary"
                icon="el-icon-document"
                @click="gameList"
                class="send"
                >gameList</el-button
              >
            </div>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.gameList"
              readonly
            >
            </el-input>
          </div>
          <div class="apiBox">
            <span class="apiTitle">gameList(POST)</span>
           
            <el-input v-model="gamelistPost.lang" maxlength="60">
              <template slot="prepend">lang</template>
              <el-button
                slot="append"
                icon="el-icon-position"
                @click="gameListPost"
                class="send"
              ></el-button>
            </el-input>

            <el-input
              class="responseBox"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="API Response"
              v-model="responselist.gameListPost"
              readonly
            >          
            </el-input>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gameapiService } from "../service/gameApiService.js";
import { md5Service } from "../service/md5Service.js";
import { configData } from "../config/config.js";
import SelectLineHelper from "../service/selectLineService";

export default {
  name: "ApiDocument",
  data() {
    return {
      formData: {
        playerID: "",
        gameCode: "",
        checkValue: "",
      },
      playGameForm: {
        playerID: "",
        gameCode: "",
        returnUrl: "",
        hasCurrency: null,
        hasLogo: null,
        lang: "zh-CN",
        walletType: 0,
        checkValue: "",
      },
      checkTransferForm: {
        transferID: "",
        checkValue: "",
      },
      createPlayerForm: {
        playerID: "",
        checkValue: "",
      },
      kickPlayerForm: {
        actionType: "",
        playerID: "",
        checkValue: "",
      },
      trialPlayGameForm: {
        gameCode: "",
        checkValue: "",
      },
      queryPointForm: {
        playerID: "",
        checkValue: "",
      },
      depositForm: {
        playerID: "",
        transferID: "",
        pointAmount: "",
        checkValue: "",
      },
      withdrawalForm: {
        playerID: "",
        transferID: "",
        pointAmount: "",
        pickType: "",
        checkValue: "",
      },
      lockPlayerForm: {
        playerID: "",
        checkValue: "",
      },
      unLockPlayerForm: {
        playerID: "",
        checkValue: "",
      },
      gameRecordByTimeForm: {
        beginDateTime: "",
        endDateTime: "",
        gameType: "",
      },
      tradeRecordByTimeForm: {
        beginDateTime: "",
        endDateTime: "",
        playerID: "",
      },
      playerStatusForm: {
        playerID: "",
      },
      playerGameDetail: {
        gameTurn: "",
        checkValue: "",
      },
      playerDailyReport: {
        gameDate: "",
        checkValue: "",
      },
      playerspoint: {
        playerIDList: [],
        checkValue: "",
      },
      onlineplayers: {
        pageIndex: "",
        pageSize: "",
        checkValue: "",
      },
      tmpId: "",
      merchantCode: configData.merchantCode,
      agentKey: configData.agentKey,
      domainName: configData.domain,
      header: "",
      CheckSum: "",
      playerID: "",
      responselist: {
        createPlayer: "",
        kickPlayer: "",
        lockPlayer: "",
        unLockPlayer: "",
        playerStatus: "",
        playGame: "",
        playLobby: "",
        trialPlayGame: "",
        deposit: "",
        withdrawal: "",
        checkTransfer: "",
        queryPoint: "",
        gamerecordbyTime: "",
        tradeRecordByTime: "",
        onlineplayers: "",
        playerGameDetail: "",
        playerdailyreport: "",
        playerspoint: "",
        jackpotstatus: "",
        gameList: "",
        gameListPost: "",
      },
      showBack: true,
      initNum: 0,
      gamelistPost: {
        lang: ""
      }
    };
  },
  mounted() {
    if ("staging" == configData.envName || "prod" == configData.envName) {
      this.merchantCode = "";
      this.agentKey = "";
      this.domainName = "";
      this.showBack = false;
    }

    this.startSelectLine();
  },
  watch: {
    merchantCode(value) {
      configData.merchantCode = value;
    },
    agentKey(value) {
      configData.agentKey = value;
    },
    domainName(value) {
      configData.domain = value;
    },
    initNum(val) {
      if (configData.envName == "staging" && val == 10) {
        this.merchantCode = "873e89f98d9c4523b36b34a22898595f";
        this.agentKey = "dev3001";
        this.domainName = "dev001";
        this.initNum = 0;
      }

      if(configData.envName =="dev" || configData.envName =="qc" || configData.envName =="demosite")
      {
        if(configData.currentLang == "th")
        {
          this.merchantCode=configData.merchantCodeTH;         
          this.domainName=configData.domainTH;
          this.agentKey=configData.agentKeyTH;          
        }
        else
        {
          this.merchantCode=configData.merchantCodeCN;
          this.domainName=configData.domainCN;
          this.agentKey=configData.agentKeyCN;     
        }
      } 


    },
  },
  methods: {
    initDoc() {
      this.initNum++;
    },
    goBack() {
      this.$router.push({ path: "/" });
    },
    changeKey() {
      configData.agentKey = this.agentKey;
    },
    changeDomain() {
      configData.domain = this.domainName;
    },
    getGameDetail() {
      this.playerGameDetail.checkValue = md5Service.detailEnc([
        this.playerGameDetail.gameTurn,
      ]);

      this.showRequest();
      gameapiService.querygamedetail(this.playerGameDetail).then((res) => {
        let CheckSum =
          this.merchantCode + this.agentKey + this.playerGameDetail.gameTurn;
        let responseTmp = this.output(res.data);

        this.responselist.playerGameDetail = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.playerGameDetail
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },

    startSelectLine() {
      let selectLineHelper = new SelectLineHelper();
      selectLineHelper.init();
      selectLineHelper.setConfigLocation(configData.lineUrl);
      selectLineHelper.setFinishJob((info, data) => {
        configData.frontendAPI = data.frontendAPI;
      });
      selectLineHelper.startSelectLine();
    },
    getJackpotStatus() {
      this.showRequest();
      gameapiService.getjackpotstatus().then((res) => {
        let CheckSum = "";
        let responseTmp = this.output(res.data);
        this.responselist.jackpotstatus = `Header:${JSON.stringify(
          this.header
        )}\nRequest:\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    playGame2() {
      this.playGameForm.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.playGameForm.playerID,
        this.playGameForm.gameCode,
      ]);
      this.showRequest();

      gameapiService.playGame(this.playGameForm).then((res) => {
        let CheckSum =
          this.merchantCode +
          this.agentKey +
          this.playGameForm.playerID +
          this.playGameForm.gameCode;

        let responseTmp = this.output(res.data);
        this.responselist.playGame = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.playGameForm
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    playLobby2() {
      this.formData.gameCode = "";
      this.formData.playerID = this.tmpId;
      this.formData.checkValue = md5Service.enc([
        this.formData.playerID,
        this.formData.gameCode,
      ]);
      this.showRequest();

      gameapiService.playlobby(this.formData).then((res) => {
        let CheckSum =
          this.merchantCode +
          this.agentKey +
          this.formData.playerID +
          this.formData.gameCode;

        let responseTmp = this.output(res.data);
        this.responselist.playLobby = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.formData
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    checkTransfer() {
      this.checkTransferForm.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.checkTransferForm.transferID,
      ]);

      this.showRequest();
      gameapiService.checkTransfer(this.checkTransferForm).then((res) => {
        let CheckSum =
          this.merchantCode + this.agentKey + this.checkTransferForm.transferID;
        let responseTmp = this.output(res.data);
        this.responselist.checkTransfer = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.checkTransferForm
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    createPlayer() {
      this.createPlayerForm.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.createPlayerForm.playerID,
      ]);
      this.showRequest();
      gameapiService.createPlayer(this.createPlayerForm).then((res) => {
        let CheckSum =
          this.merchantCode + this.agentKey + this.createPlayerForm.playerID;
        let responseTmp = this.output(res.data);
        this.responselist.createPlayer = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.createPlayerForm
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    kickPlayer() {
      this.kickPlayerForm.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.kickPlayerForm.actionType,
      ]);

      this.showRequest();
      gameapiService.kickPlayer(this.kickPlayerForm).then((res) => {
        let CheckSum =
          this.merchantCode + this.agentKey + this.kickPlayerForm.actionType;
        let responseTmp = this.output(res.data);

        this.responselist.kickPlayer = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.kickPlayerForm
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    trialPlayGame() {
      this.trialPlayGameForm.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.trialPlayGameForm.gameCode,
      ]);

      this.showRequest();

      gameapiService.trialPlayGame(this.trialPlayGameForm).then((res) => {
        let CheckSum =
          this.merchantCode + this.agentKey + this.trialPlayGameForm.gameCode;
        let responseTmp = this.output(res.data);

        this.responselist.trialPlayGame = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.trialPlayGameForm
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    queryPoint() {
      this.queryPointForm.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.queryPointForm.playerID,
      ]);

      this.showRequest();

      gameapiService.queryPoint(this.queryPointForm).then((res) => {
        let CheckSum =
          this.merchantCode + this.agentKey + this.queryPointForm.playerID;

        let responseTmp = this.output(res.data);

        this.responselist.queryPoint = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.queryPointForm
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    deposit() {
      this.depositForm.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.depositForm.playerID,
        this.depositForm.transferID,
        this.depositForm.pointAmount,
      ]);

      this.showRequest();
      gameapiService.deposit(this.depositForm).then((res) => {
        let CheckSum =
          this.merchantCode +
          this.agentKey +
          this.depositForm.playerID +
          this.depositForm.transferID +
          this.depositForm.pointAmount;

        let responseTmp = this.output(res.data);
        this.responselist.deposit = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.depositForm
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    withdrawal() {
      this.withdrawalForm.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.withdrawalForm.playerID,
        this.withdrawalForm.pickType,
        this.withdrawalForm.transferID,
        this.withdrawalForm.pointAmount,
      ]);

      this.showRequest();
      gameapiService.withdrawal(this.withdrawalForm).then((res) => {
        let CheckSum =
          this.merchantCode +
          this.agentKey +
          this.withdrawalForm.playerID +
          this.withdrawalForm.pickType +
          this.withdrawalForm.transferID +
          this.withdrawalForm.pointAmount;
        let responseTmp = this.output(res.data);
        this.responselist.withdrawal = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.withdrawalForm
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    lockPlayer() {
      this.lockPlayerForm.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.lockPlayerForm.playerID,
      ]);

      this.showRequest();
      gameapiService.lockPlayer(this.lockPlayerForm).then((res) => {
        let CheckSum =
          this.merchantCode + this.agentKey + this.lockPlayerForm.playerID;

        let responseTmp = this.output(res.data);
        this.responselist.lockPlayer = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.lockPlayerForm
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    unLockPlayer() {
      this.unLockPlayerForm.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.unLockPlayerForm.playerID,
      ]);

      this.showRequest();
      gameapiService.unLockPlayer(this.unLockPlayerForm).then((res) => {
        let CheckSum =
          this.merchantCode + this.agentKey + this.unLockPlayerForm.playerID;
        let responseTmp = this.output(res.data);
        this.responselist.unLockPlayer = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.unLockPlayerForm
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    gameList() {
      this.showRequest();
      gameapiService.gameList().then((res) => {
        let CheckSum = "";
        let responseTmp = this.output(res.data);
        this.responselist.gameList = `Header:${JSON.stringify(
          this.header
        )}\nRequest:\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    gameListPost() {
      this.showRequest();
      gameapiService.gameListPost(this.gamelistPost).then((res) => {
        let CheckSum = "";
        let responseTmp = this.output(res.data);
        this.responselist.gameListPost = `Header:${JSON.stringify(
          this.header
        )}\nRequest:\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    gameRecordByTime() {
      this.gameRecordByTimeForm.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.gameRecordByTimeForm.beginDateTime,
        this.gameRecordByTimeForm.endDateTime,
        this.gameRecordByTimeForm.gameType,
      ]);

      this.showRequest();
      gameapiService.gameRecordByTime(this.gameRecordByTimeForm).then((res) => {
        let CheckSum =
          this.merchantCode +
          this.agentKey +
          this.gameRecordByTimeForm.beginDateTime +
          this.gameRecordByTimeForm.endDateTime +
          this.gameRecordByTimeForm.gameType;

        let responseTmp = this.output(res.data);

        this.responselist.gamerecordbyTime = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.gameRecordByTimeForm
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    tradeRecordByTime() {
      this.tradeRecordByTimeForm.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.tradeRecordByTimeForm.beginDateTime,
        this.tradeRecordByTimeForm.endDateTime,
      ]);

      this.showRequest();
      gameapiService
        .tradeRecordByTime(this.tradeRecordByTimeForm)
        .then((res) => {
          let CheckSum =
            this.merchantCode +
            this.agentKey +
            this.tradeRecordByTimeForm.beginDateTime +
            this.tradeRecordByTimeForm.endDateTime;

          let responseTmp = this.output(res.data);

          this.responselist.tradeRecordByTime = `Header:${JSON.stringify(
            this.header
          )}\nRequest:${JSON.stringify(
            this.tradeRecordByTimeForm
          )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
        });
    },
    playerStatus() {
      this.playerStatusForm.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.playerStatusForm.playerID,
      ]);

      this.showRequest();
      gameapiService.queryplayerstatus(this.playerStatusForm).then((res) => {
        let CheckSum =
          this.merchantCode + this.agentKey + this.playerStatusForm.playerID;

        let responseTmp = this.output(res.data);
        this.responselist.playerStatus = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.playerStatusForm
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    getPlayerDailyReport() {
      this.playerDailyReport.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.playerDailyReport.gameDate,
      ]);

      this.showRequest();
      gameapiService.playerdailyreport(this.playerDailyReport).then((res) => {
        let CheckSum =
          this.merchantCode + this.agentKey + this.playerDailyReport.gameDate;
        let responseTmp = this.output(res.data);

        this.responselist.playerdailyreport = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.playerDailyReport
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    getplayerspoint() {
      this.playerspoint.playerIDList = this.playerID.split(",");
      this.playerspoint.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
      ]);

      this.showRequest(this.playerspoint);
      gameapiService.getplayerspoint(this.playerspoint).then((res) => {
        let CheckSum = this.merchantCode + this.agentKey;
        let responseTmp = this.output(res.data);

        this.responselist.playerspoint = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.playerspoint
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    getonlineplayers() {
      this.onlineplayers.checkValue = md5Service.encWithoutKey([
        this.merchantCode,
        this.agentKey,
        this.onlineplayers.pageIndex,
        this.onlineplayers.pageSize,
      ]);

      this.showRequest();
      gameapiService.getonlineplayers(this.onlineplayers).then((res) => {
        let CheckSum =
          this.merchantCode +
          this.agentKey +
          this.onlineplayers.pageIndex +
          this.onlineplayers.pageSize;

        let responseTmp = this.output(res.data);

        this.responselist.onlineplayers = `Header:${JSON.stringify(
          this.header
        )}\nRequest:${JSON.stringify(
          this.onlineplayers
        )}\nCheckSumInput:${CheckSum}\nResponse:${responseTmp}`;
      });
    },
    output(data) {
      return JSON.stringify(data, null, "\t");
    },
    showRequest() {
      this.header = {
        "Content-Type": "application/json",
        agent: configData.agentKey,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ApiDocument {
  background-color: #1e1e1e;
  color: #ccc;
}

.top {
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 1.5px;
  color: #fff;
  text-shadow: 0 0 2px #00ebfe, 1px 1px 2px #00ebfe;
  box-shadow: 0 2px 8px #00ebfe;
  background-color: #000;
  user-select: none !important;
}

#logo {
  width: 36px;
  margin: 8px;
}

.content {
  padding: 20px 10px;
}

.backBtn {
  width: 100px;
  padding: 8px;
  font-weight: 900;
  color: #fff;
  text-shadow: 0 0 2px #e704c2, 1px 1px 2px #e704c2;
  border: 2px solid #e704c2;
  box-shadow: 0 0 3px 2px #fff;
  border-radius: 5px;
  cursor: pointer;
}

.agnetBox {
  margin: 20px 0 30px 0;
}

.agentType {
  margin: 2px 0;
}

.groupTitle {
  font-weight: 900;
  color: #ffb700;
  margin: 10px 0 20px 0;
  letter-spacing: 1.5px;
}

.group {
  margin: 50px 0;
}
.apiBox {
  margin: 30px 0;
  text-align: left;
}
.apiTitle {
  line-height: 36px;
}

.send {
  background-color: #ffb700 !important;
  color: #1e1e1e !important;
  font-weight: 900;
  border: 2px solid rgb(34, 34, 34) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ApiDocument.vue